module.exports = __webpack_public_path__ + "img/icn_informativo.e37ab447.svg";